import {
  ArtworkAifilterStyleDTO,
  ResponseDTO,
  ResponseDTOAllArtworkAifilterStyleDTO,
  ResponseDTOArtworkAifilterStyleDTO,
  ResponseDTOBoolean,
  ResponseDTOPageArtworkAifilterStyleDTO,
} from '@/types/filter';
import axiosInstance from './axiosInstance';
import type { AxiosResponse } from 'axios';
const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

/**
 * 修改风格数据
 * @param {*} params
 * @returns
 */
export const updateArtworkAiFilterStyle = async (
  params: ArtworkAifilterStyleDTO
): Promise<AxiosResponse<ResponseDTOBoolean>> => {
  const response = await axiosInstance.post(
    `${baseUrl}/artworkAiFilterStyle/update`,
    params
  );

  return response;
};

/**
 * 分页查询列表数据
 * @param {*} params
 * @returns
 */
export const getArtworkAiFilterStylePage = async (
  params: ArtworkAifilterStyleDTO & {
    pageNum: number;
    pageSize: number;
  }
): Promise<AxiosResponse<ResponseDTOPageArtworkAifilterStyleDTO>> => {
  const response = await axiosInstance.post(
    `${baseUrl}/artworkAiFilterStyle/page?pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
    params
  );

  return response;
};

/**
 * 删除风格数据
 * @param {*} params
 * @returns
 */
export const deleteArtworkAiFilterStyleByStyleType = async (params: {
  styleType: string;
}): Promise<AxiosResponse<ResponseDTOBoolean>> => {
  const response = await axiosInstance.post(
    `${baseUrl}/artworkAiFilterStyle/delete/${params.styleType}`,
    params
  );

  return response;
};

/**
 * 删除风格数据
 * @param {*} params
 * @returns
 */
export const deleteArtworkAiFilterStyleByStyleId = async (params: {
  styleId: number;
}): Promise<AxiosResponse<ResponseDTOBoolean>> => {
  const response = await axiosInstance.post(
    `${baseUrl}/artworkAiFilterStyle/deleteByStyleId/${params.styleId}`,
    params
  );

  return response;
};

/**
 * 新增风格数据
 * @param {*} params
 * @returns
 */
export const postArtworkAiFilterStyleAdd = async (
  params: ArtworkAifilterStyleDTO
): Promise<AxiosResponse<ResponseDTOBoolean>> => {
  const response = await axiosInstance.post(
    `${baseUrl}/artworkAiFilterStyle/add`,
    params
  );

  return response;
};

/**
 * 查询全部风格类型
 * @param {*}
 * @returns
 */
export const getAllArtworkAiFilterStyle = async (): Promise<
  AxiosResponse<ResponseDTOAllArtworkAifilterStyleDTO>
> => {
  const response = await axiosInstance.get(
    `${baseUrl}/artworkAiFilterStyle/styleTypeAll`
  );

  return response;
};

/**
 * 详情
 * @param {*} params
 * @returns
 */
export const getArtworkAiFilterStyleDetail = async (params: {
  styleId: number;
}): Promise<AxiosResponse<ResponseDTOArtworkAifilterStyleDTO>> => {
  const response = await axiosInstance.get(
    `${baseUrl}/artworkAiFilterStyle/detail/${params.styleId}`,
    { params }
  );

  return response;
};
